/**
 * Return the cookie value mapped to the name passed to the function
 * @type {function}
 * @param {string} cookieName
 * @return {string}
 */
export const getCookie = (cookieName) => {
    const regex = new RegExp(`(?:;\\s)*${cookieName}=([^;]*)`);
    const match = document.cookie.match(regex);
    if (match) {
        const cookieValue = match[1];
        return cookieValue;
    }
    return '';
};

/**
 * Creates a new cookie and returns true after the cookie is set
 * @param {string} cookieName
 * @param {*} value
 * @param {string} expiration
 * @param {boolean} secure
 * @return {boolean}
 */
export const setCookie = (
    cookieName,
    value,
    expiration = '',
    secure = false
) => {
    const isSecure = secure && window.location.protocol === 'https:';
    document.cookie = `${cookieName}=${value}; path=/;expires=${expiration}${
        isSecure ? ';secure' : ''
    }`;
    return true;
};

/**
 * Deletes the given cookie and returns true
 * @param {string} cookieName
 * @return {boolean}
 */
export const deleteCookie = (cookieName) => {
    document.cookie = `${cookieName}=; path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
    return true;
};
